import React, { useEffect, useState } from 'react'

export default function Intermideat() {
     const [country, setCountry] = useState("");
     useEffect(()=>{
     })
  return (
    <div>
      
    </div>
  )
}
